type HistoryState = {
  name: string | undefined | symbol;
  path: string;
  fullPath: string;
  params: Record<string, string>;
  query: Record<string, string | null>;
};

function limitArrLength<T>(arr: T[], length: number) {
  if (arr.length > length) {
    arr.splice(0, arr.length - length);
  }
}

const routeHistoryCacheLength = 10;

const pushSymbol = Symbol('pushSymbol');

/**
 *
 * 限制只保留10个历史记录
 * 暂时只拦截push和set操作
 */
export const useRouteHistory = () => {
  const routeHistory = useState<HistoryState[]>('routeHistory', () => []);

  return computed<HistoryState[]>({
    set(val) {
      if (!import.meta.client) {
        return;
      }

      routeHistory.value = val;
      limitArrLength(routeHistory.value, routeHistoryCacheLength);
    },
    get() {
      const rawCache = toRaw(routeHistory.value);

      if (!rawCache[pushSymbol as any]) {
        Object.defineProperty(rawCache, pushSymbol, {
          enumerable: false,
          value: true,
        });

        const oldPush = rawCache.push;

        Object.defineProperty(rawCache, 'push', {
          enumerable: false,
          writable: true,
          value: (...items: HistoryState[]) => {
            if (!import.meta.client) {
              return 0;
            }
            oldPush.apply(rawCache, items);
            limitArrLength(routeHistory.value, routeHistoryCacheLength);
            return routeHistory.value.length;
          },
        });
      }

      return routeHistory.value;
    },
  });
};
